import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        My <strong className="purple">Coding</strong> Days
      </h1>
      <GitHubCalendar
        username="Filmon12345"
        blockSize={15}
        blockMargin={5}
        color="#e0e41d"
        fontSize={16}
      />
    </Row>
  );
}

export default Github;
